export const updateFromFields = [
  {
    type: "autocomplete",
    label: "Course Number",
    field: "Course#",
  },
  {
    type: "autocomplete",
    label: "Course Name",
    field: "courseName",
  },
  {
    type: "autocomplete",
    label: "Course Location",
    field: "courseLocation",
  },
  {
    type: "autocomplete",
    label: "Category",
    field: "category",
  },
];

export const updateToFields = [
  {
    type: "text",
    label: "Course Number",
    field: "Course#",
  },
  {
    type: "text",
    label: "Course Name",
    field: "courseName",
  },
  {
    type: "text",
    label: "Course Location",
    field: "courseLocation",
  },
  {
    type: "text",
    label: "Category",
    field: "category",
  },
];

export const backendFieldsMap = {
  courseLocation: {
    trainingCourse: "location",
    perTraining: "courseLocation",
  },
  courseName: {
    trainingCourse: "courseName",
    perTraining: "course",
  },
  category: {
    trainingCourse: "category",
    perTraining: "category",
  },
  "Course#": {
    trainingCourse: "courseNumber",
    perTraining: "courseNumber",
  },
};
